import { createMemberNameString } from '@members/store/members.selectors';

import { type AssignableInternalAssignee } from '@tasksDecisions/tasksDecisions.types';

import { type Member } from '@organisations/types';

export const getUserNameLabel = (
    member: Member | AssignableInternalAssignee,
    translations: { [key: string]: string },
    isLoggedMember: boolean
): string => {
    const { user } = member;
    const { firstName, lastName } = user;
    const fullName = createMemberNameString(member);

    return isLoggedMember ? `${translations.ME} (${firstName} ${lastName})` : fullName;
};

export const getIdsFromList = (list: { id: string }[] = []) => list.map(({ id }) => id) ?? [];

export const uniqById = <T extends { id?: string }>(list: T[]): T[] => {
    const clonedList = [...list];
    const seen = new Set<string | undefined>();
    return clonedList.filter((item) => {
        const id = item?.id;
        if (seen.has(id)) return false;
        seen.add(id);
        return true;
    });
};
